import React from 'react';

const ApplicationsChart = () => {
  // For now, we'll use a placeholder. You can integrate Chart.js later
  return (
    <div className="h-64 bg-gray-100 rounded-lg flex items-center justify-center">
      <p className="text-gray-500">Application Trends Chart</p>
    </div>
  );
};

export default ApplicationsChart;